import React, { Fragment } from 'react';
import { BulkDeleteButton } from 'react-admin';

const BulkAB = props => (
    <Fragment>
        <BulkDeleteButton mutationMode="pessimistic" {...props} />
    </Fragment>
);
export default BulkAB;